// Vendor Libs
import React from 'react';
import {Provider} from 'react-redux';
import {BrowserRouter, Route} from 'react-router-dom';
import {hot} from 'react-hot-loader/root';

// Redux
import store from './redux/store';

// Components
import AuthLayout from './components/AuthLayout';

const App = () => (
  <Provider store={store}>
    <BrowserRouter>
      <Route component={AuthLayout} path="/" />
    </BrowserRouter>
  </Provider>
);

export default Config.base.env === 'development' ? hot(App) : App;
